/**
 * Utility functions for checking user verification status and access control
 */

/**
 * Check if the current user has pending verification status
 * @returns {boolean} True if verification is pending (documents uploaded but not approved), false otherwise
 */
export const hasUserPendingVerification = () => {
  const verificationStatus = sessionStorage.getItem("usr_verification_status");
  const isUploaded = sessionStorage.getItem("usr_is_uploaded");
  const roleId = sessionStorage.getItem("usr_role_id");

  // For doctors (role_id 4), check if documents are uploaded and verification is pending
  if (roleId === "4") {
    return isUploaded === "true" && verificationStatus === "PENDING";
  }

  return false;
};

/**
 * Check if the current user should have restricted access
 * @returns {boolean} True if user should have restricted access (view only), false otherwise
 */
export const shouldRestrictAccess = () => {
  return hasUserPendingVerification();
};

/**
 * Get user verification status
 * @returns {string|null} Verification status or null
 */
export const getUserVerificationStatus = () => {
  return sessionStorage.getItem("usr_verification_status");
};

/**
 * Get user is_uploaded status
 * @returns {boolean} True if documents are uploaded, false otherwise
 */
export const getUserIsUploaded = () => {
  const isUploaded = sessionStorage.getItem("usr_is_uploaded");
  return isUploaded === "true";
};

/**
 * Check if user is a doctor
 * @returns {boolean} True if user is a doctor (role_id 4), false otherwise
 */
export const isDoctor = () => {
  const roleId = sessionStorage.getItem("usr_role_id");
  return roleId === "4";
};
